import React, { useState, Fragment, useEffect } from "react";
import "./styles.css";
import data from "../../common/assets/files/country_code_flag_number.json";
import { useSelector } from "react-redux";

interface DialCodePickerProps {
  inputValue: string;
  showPicker: Boolean;
  setShowPicker: any;
  setCountryData: any;
  setIsMobile: any;
  countryCode?:any;
  onlyMobile: Boolean;
  setCountrySelected?: any;
  isMobileNot?:boolean;
  isAccountScreen?: boolean;
  width?:string;
  top?:string
  height?:string
}

export interface CountryCodeData {
  code: string;
  flag: string;
}

function DialCodePicker(props: DialCodePickerProps) {
  // Disp or nor the Dial Code

  const restaurantDetails = useSelector(
         (state: any) => state.restaurant.currentRestaurantDetail
       );
  useEffect(() => {
    if (!props.onlyMobile) {
      if (props.inputValue != "") {
        if (props.inputValue.match(/.*[a-zA-Z@]+.*/)) {
          props.setIsMobile(false);
        } else {
          props.setIsMobile(true);
        }
      } else {
        props.setIsMobile(false);
      }
    }
  }, [props.inputValue]);
 useEffect(() => {
  const codeToMatch = props.countryCode || restaurantDetails?.country;
  if (codeToMatch) {
    const matchedCountry = data.find(
      (country) => country.code === codeToMatch || country.number === codeToMatch
    );
    if (matchedCountry) {
      props.setCountryData({
        code: matchedCountry.number,
        flag: matchedCountry.flag,
      });
      if (props.setCountrySelected) {
        props.setCountrySelected(matchedCountry);
      }
    }
  }
}, [props.countryCode, restaurantDetails?.country]);
 
  return (
    <>
      {props.showPicker ? (
          <div
            id={props.isMobileNot ? "suggestionContainer-D" : props?.isAccountScreen ? 'suggestionContainer-accounts' : "suggestionContainer"}
          style={{width:props.width?props.width:"80%",
            top:props.top?props.top:"",
            height:props?.height?props?.height:""
          }}
            className={props.showPicker ? "showPick" : ""}
          >
            {data.map((country) => {
              return (
                <div
                  key={country.name}
                  className="suggestionCountry"
                  onClick={() => {
                    props.setCountryData({
                      code: country.number,
                      flag: country.flag,
                    });
                    props.setShowPicker(false);
                  }}
                >
                  <img
                    src={country.flag}
                    height={"15px"}
                    width={"30px"}
                    className="flag"
                  />{" "}
                  &nbsp; {country.name} &nbsp;({country.number})
                </div>
              );
            })}
          </div>
      ) : null}
    </>
  );
}
export default DialCodePicker;
